// extracted by mini-css-extract-plugin
export default {"container":"styles_container__2sXU7","v2":"styles_v2__H+j69","percent":"styles_percent__V1MCJ","progress":"styles_progress__dr7dP","background":"styles_background__fSLZD"};